import { trpc } from '@/shared/api';

/** 결제 승인(payments.confirm) — 성공 페이지가 마운트 때 한 번 부른다. */
export const useConfirmPayment = () => trpc.payments.confirm.useMutation();
